import { configureStore } from '@reduxjs/toolkit'
import colorSelectorReducer from './colorSelectorSlice'

export const store = configureStore({
  reducer: {
    colorSelector: colorSelectorReducer,
  },
})